import Vue from 'vue'
import Router from 'vue-router'
import HomePage from "@/pages/HomePage";
import LoginPage from "../pages/LoginPage";
import RegisterPage from "../pages/RegisterPage";
import PersonalCenterPage from "../pages/PersonalCenterPage";
import GroupCenterPage from "../pages/GroupCenterPage";
import IntroducePage from "../pages/IntroducePage";
import BasketballMatchesPage from "../pages/BasketballMatchesPage";
import BasketballTrainingPage from "../pages/BasketballTrainingPage";
import NewCenterPage from "../pages/NewCenterPage";
import OtherAssociationsPage from "../pages/OtherAssociationsPage";
import SearchPage from "../pages/SearchPage";
import ForgetPasswordPage from "../pages/ForgetPasswordPage";
import MatchDetailPage from "../pages/MatchDetailPage";
import TrainingActivityListPage from "../pages/TrainingActivityListPage";
import TestWechatLogin from "../pages/TestWechatLogin";
import WeixinLoginBind from "../pages/WeixinLoginBind";
import TrainingCourseDetailPage from "../pages/TrainingCourseDetailPage";
import MatchListPage from "../pages/MatchListPage";


import DefaultConfig from '../js/shba'
import OuterGamesList from "../pages/outer-matches/OuterGamesList";
import OuterGameDetail from "../pages/outer-matches/OuterGameDetail";
import OuterGameHome from "../pages/outer-matches/OuterGameHome";
import MatchPlayerDetailPage from "../pages/outer-matches/MatchPlayerDetailPage";
import RefereeListPage from "../pages/RefereeListPage";
import RefereeDetailPage from "../pages/RefereeDetailPage";

import MyTestPage from "../pages/MyTestPage";
import RefereePage from "../pages/RefereePage";
import PersonalHomePage from "../components/personal/PersonalHomePage";
import PersonalGroup from "../components/personal/PersonalGroup";
import PersonalVipsDetail from "../components/personal/PersonalVipsDetail";
import UserTrainingList from "../components/common/UserTrainingList";
import PersonalVipApplication from "../components/personal/PersonalVipApplication";
import PersonalSetting from "../components/personal/PersonalSetting";
import PersonalNotificationCenter from "../components/personal/PersonalNotificationCenter";
import ProfessionalCertsList from "../pages/ProfessionalCertsList";
import ProfessionalCertApplication from "../pages/ProfessionalCertApplication";
import GroupHomePage from "../components/group/GroupHomePage";
import GroupMember from "../components/group/GroupMember";
import GroupVipApplication from "../components/group/GroupVipApplication";

import CoachCertification from "../components/personal/coachApplications/CoachCertification.vue";

import CoachPage from "../pages/CoachPage.vue";
import CoachListPage from "../pages/CoachListPage.vue";
import CoachDetailPage from "../pages/CoachDetailPage.vue";

Vue.use(Router)

const metaTitle = '上海市篮球协会';

export default new Router({
  mode: 'history',
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter');
    // next(false);
  },
  beforeRouteUpdate(to,frome, next) {
    console.log('beforeRouteUpdate');
  },
  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave');
  },
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: HomePage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/login',
      name:'loginPage',
      component: LoginPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/register',
      name: 'registerPage',
      component: RegisterPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: DefaultConfig.personUrl + '/center',
      name: 'personalPage',
      component: PersonalCenterPage,
      children: [
        {
          path: '/',
          redirect: 'home',
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/home',
          name: 'personalHomeVue',
          component: PersonalHomePage,
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/team',
          name: 'personalTeamVue',
          component: PersonalGroup
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/member',
          name: 'personalMemberVue',
          component: PersonalVipsDetail
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/trains',
          name: 'personalTrainsVue',
          component: UserTrainingList
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/application',
          name: 'personalApplicationVue',
          component: PersonalVipApplication
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/setting',
          name: 'personalSettingVue',
          component: PersonalSetting
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/note',
          name: 'personalNoteVue',
          component: PersonalNotificationCenter
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/certificates',
          name: 'personalCertificatesVue',
          component: ProfessionalCertsList
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/certapplication/:certId',
          name: 'personalCertificateApplicationVue',
          component: ProfessionalCertApplication
        },
        {
          path: DefaultConfig.personUrl + '/center' + '/coachapplicaiton/:certId',
          name: 'personalCoachCertApplicationVue',
          component: CoachCertification
        }
      ],
      meta: {
        title: metaTitle
      }
    },
    {
      path: DefaultConfig.groupUrl + '/center',
      name: 'groupPage',
      component: GroupCenterPage,
      children: [
        {
          path: '/',
          redirect: 'home',
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/home',
          name: 'groupHomeVue',
          component: GroupHomePage,
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/team',
          name: 'groupTeamVue',
          component: GroupMember
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/member',
          name: 'groupMemberVue',
          component: PersonalVipsDetail
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/trains',
          name: 'groupTrainsVue',
          component: UserTrainingList
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/application',
          name: 'groupApplicationVue',
          component: GroupVipApplication
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/setting',
          name: 'groupSettingVue',
          component: PersonalSetting
        },
        {
          path: DefaultConfig.groupUrl + '/center' + '/note',
          name: 'groupNoteVue',
          component: PersonalNotificationCenter
        },
      ],


      meta: {
        title: metaTitle
      }
    },
    {
      path: '/introduce/:id?/:index?',
      name: 'introducePage',
      component: IntroducePage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/introduce/:id?/detail/:userId?',
      name: 'introduceDetailPage',
      component: IntroducePage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/news/:id?/:index?/:newsId?',
      name: 'new-center-page',
      component: NewCenterPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/matches',
      name: 'basketball-matches-page',
      component: BasketballMatchesPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/matches/detail/:id',
      name: 'matchDetailPage',
      component: MatchDetailPage,
      meta: {
        title: metaTitle
      }
    },

    {
      path: '/matches/list/:id',
      name: 'matchListPage',
      component: MatchListPage,
      meta: {
        title: metaTitle
      }
    },

    {
      path: '/matches/games/:id',
      name: 'matchGamesHomePage',
      component: OuterGameHome,
      meta: {
        title: metaTitle
      }
    },

    {
      path: '/matches/games/detail/:id',
      name: 'matchGamesDetailPage',
      component: OuterGameDetail,
      meta: {
        title: metaTitle
      }
    },

    {
      path: '/matches/games/player/:id',
      name: 'matchPlayerDetailPage',
      component: MatchPlayerDetailPage,
      meta: {
        title: metaTitle
      }
    },

    {
      path: '/training',
      name: 'basketballTrainingPage',
      component: BasketballTrainingPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/training/:id',
      redirect: '/training/:id/list'
    },
    {
      path: '/training/:id/list',
      name: 'TrainingListActivityPage',
      component: TrainingActivityListPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/training/course/:courseId/:index?',
      name: 'trainingCourseDetailPage',
      component: TrainingCourseDetailPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/training/:id?/detail/:newsId',
      name: 'basketball-training-detail-page',
      component: BasketballTrainingPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/training/:id?/user/:userId',
      name: 'basketball-training-user-page',
      component: BasketballTrainingPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/training/:id/referee',
      name: 'RefereePage',
      component: RefereePage,
      meta: {
        title: metaTitle
      },
      children: [
        {
          path: '/',
          redirect: 'list',
        },
        {
          path: '/training/:id/referee/list',
          component: RefereeListPage,
          name: 'listVue'
        },
        {
          path: '/training/:id/referee/detail/:refereeId',
          name: 'detailVue',
          component: RefereeDetailPage
        }
      ]
    },

    {
      path: '/training/:id/coach',
      name: 'coachPage',
      component: CoachPage,
      meta: {
        title: metaTitle
      },
      children: [
        {
          path: '/',
          redirect: 'list',
        },
        {
          path: '/training/:id/coach/list',
          component: CoachListPage,
          name: 'coachListVue'
        },
        {
          path: '/training/:id/coach/detail/:coachId',
          name: 'coachDetailVue',
          component: CoachDetailPage
        }
      ]
    },


    {
      path: '/associations',
      name: 'other-oassociations-page',
      component: OtherAssociationsPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/search/:searchText?',
      name: 'searchPage',
      component: SearchPage,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/forgetpwd/:userType?',
      name: 'ForgetPwdPage',
      component: ForgetPasswordPage,
      meta: {
        title: metaTitle,
      }
    },
    {
      path: '/user/bind',
      name: 'weixinLoginBind',
      component: WeixinLoginBind,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/ljh/testwechat',
      name: 'testWechatLogin',
      component: TestWechatLogin,
      meta: {
        title: metaTitle
      }
    },
    {
      path: '/download/test',
      name: 'testPage',
      component: MyTestPage,
      meta: {
        title: metaTitle
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js